export const flat = (
  <svg
    viewBox="0 0 9 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.16388 13.9721C5.88888 11.3082 7.96944 9.02352 7.96944 7.16658C7.96944 5.79575 7.27916 4.24991 5.05277 4.24991C4.37221 4.24991 3.70138 4.52213 3.10832 4.9013V0.361023H1.16388V13.9721ZM3.10832 10.4527V7.41936C3.7111 6.76797 4.51805 6.19436 5.05277 6.19436C5.62638 6.19436 6.02499 6.26241 6.02499 7.16658C6.02499 7.31241 5.92777 8.43047 3.10832 10.4527V10.4527Z"
      fill="#715450"
    />
  </svg>
);
